/**
 * DI-01 — the deck text for the summary turn, cut at a slide boundary under DECK_CONTEXT_CHAR_CAP
 * so the card can say how many slides it covers (G-9). An oversized first slide is clipped.
 */

import { DECK_CONTEXT_CHAR_CAP } from "../../../const";
import type { DeckContext, DeckReadResult, SlideText } from "../types";

function slideBlock(slide: SlideText): string {
  return `--- Slide ${slide.slideNumber} ---\n${slide.text.trim()}`;
}

export function buildDeckContext(slides: readonly SlideText[], cap = DECK_CONTEXT_CHAR_CAP): DeckReadResult {
  if (!slides.some((s) => s.text.trim())) return { kind: "empty" };

  const blocks: string[] = [];
  let length = 0;
  let slidesIncluded = 0;
  let clipped = false;
  for (const slide of slides) {
    if (slide.text.trim()) {
      const block = slideBlock(slide);
      const added = (blocks.length > 0 ? 2 : 0) + block.length;
      if (length + added > cap) {
        if (blocks.length === 0) {
          blocks.push(block.slice(0, cap));
          slidesIncluded = slide.slideNumber;
          clipped = true;
        }
        break;
      }
      blocks.push(block);
      length += added;
    }
    // A slide with no text is still "covered": the summary saw everything on it.
    slidesIncluded = slide.slideNumber;
  }

  const context: DeckContext = {
    text: blocks.join("\n\n"),
    slidesIncluded,
    totalSlides: slides.length,
    truncated: clipped || slidesIncluded < slides.length,
  };
  return { kind: "ok", context };
}
